// features/landing/components/Contents/Contents.tsx
import React from 'react';
import * as styles from './contents.css';

export type ContentsProps = {
  heading?: string;
  paragraphs?: string[];
};

export const Contents: React.FC<ContentsProps> = ({
  heading = 'About Us',
  paragraphs = [
    '食べて楽しい料理のお店',
    'ヘルシーで美味しい食を通じて豊かなFun Lifeをご提供',
    '全ての人が健康寿命＝平均寿命となることを目指し豊かなヘルシーライフをサポートします',
    'Welcome to Kitchen Mükü, where joy meets every bite.',
    'Our mission is to bring you wholesome, additive-free meals that energize your body and mind.',
    'We source our ingredients locally from trusted farmers, ensuring freshness and quality.',
    'From well-balanced side dishes seasoned with koji to vegetables tailored to the season, every dish is prepared with care and intention.',
    'Join us at Kitchen Mükü and discover how delicious healthy eating can be.',
    'Experience the harmony of taste and wellness, one bite at a time.',
  ],
}) => {
  return (
    <section className={styles.container} id="aboutus">
      <div className={styles.panel}>
        <h2 className={styles.heading}>{heading}</h2>
        {paragraphs.map((p, idx) => (
          <p key={idx} className={styles.paragraph}>
            {p}
          </p>
        ))}
      </div>
    </section>
  );
};

export default Contents;
